import { Injectable } from "@angular/core";

/*
 * Fichier contenant les variables globales
 *
 */
@Injectable()
export class varGlobal {
  //Contient le chemin vers l'API Rest
  pathAPI = "pathAPI";
  pathDocEcoltex = "pathDocEcoltex";
  pathDocEbizHB = "pathDocEbizHB";

  //Format pour convertir les dates provenant de l'API
  formatDate = "{0:dd-MM-yyyy hh:mm:ss}";
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/shared/varGlobal.ts